module.exports = __webpack_public_path__ + "0af5d249/img/arrow-share-icon.00a12c29.svg";